






import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class App extends Vue {
  private created() {
    let state = sessionStorage.getItem("state");
    if (state) {
      this.$store.replaceState(
        Object.assign(this.$store.state, JSON.parse(state))
      );
      sessionStorage.removeItem("state");
    }
  }

  private mounted() {
    // 保证页面刷新时store的值不丢失
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
    window.onresize = () => {
      //屏幕尺寸变化就重新计算时间轴
      return (() => {
        const time = new Date().getTime();
        this.$store.commit("updateResizeTime", time);
      })();
    };
    // 保证点击页面的后退和前进按钮时模块选中效果同时变化
    // window.addEventListener("popstate", e => {
    //   this.$store.commit("setHistory", e.target.location.href);
    // });
  }
  beforeDestroy() {
    window.removeEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
    // window.removeEventListener("popstate");
  }
}
